import React from "react";
import flowers from "../data/celeMaiVindute";
import FlowerContainer from "../components/FlowerContainer";

const CeleMaiVindute = () => {
  return (
    <FlowerContainer
      flowers={flowers}
      title="Cele mai vindute buchete"
      subtitle="Indiferent dacă vrei să îți exprimi dragostea, recunoștința sau să oferi un gest elegant, avem buchetul perfect pentru tine."
      storageKey="CELE_MAI_VINDUTE_SCROLL_POSITION"
    />
  );
};

export default CeleMaiVindute;
